import { format } from 'date-fns';
import { Event } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { downloadJSONToCSV } from '@src/utils/download-utils';
import { getEventTheme } from './oracle-taxonomy-utils';

type CsvRow = Record<string, string>;

const EVENT_CSV_COLUMNS: readonly [string, (event: Event) => string | undefined][] = [
  ['ID', event => event.id],
  ['Event Type', event => event.kind],
  ['CID', event => event.cid],
  ['Origin', event => event.origin],
  ['Status', event => event.status],
  ['Date', event => event.date],
  ['Source', event => event.source],
  ['Title', event => event.title],
  ['Theme', event => getEventTheme(event.eventType)],
  ['Category', event => event.eventType],
  ['Signal Tag', event => event.signalTag],
  ['Importance', event => event.importance],
  ['Details', event => event.details]
];

export const toEventCsvRows = (events: Event[]): CsvRow[] =>
  events.map(event =>
    Object.fromEntries(
      EVENT_CSV_COLUMNS.map(([header, getValue]) => [header, getValue(event) ?? ''])
    )
  );

export const downloadEvents = (events: Event[]): void => {
  if (events.length === 0) return;
  downloadJSONToCSV(toEventCsvRows(events), `activity-feed-${format(new Date(), 'yyyy-MM-dd')}`, {
    escapeFormulae: true
  });
};
